import React from 'react';
import { normDateToShortAmericanDate } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import { useHistory } from 'react-router-dom';
import { ProductTemplate, ProductTemplateStatus } from 'types/productServiceV2';
import { PRODUCT_LINES_CONTENT_MAP } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import StatusTag from 'components/rfq/product-template/rfq-product-templates/StatusTag';
import { observer } from 'mobx-react-lite';
import { PRODUCT_TEMPLATES_TABLE_ROW_TEST_ID } from '../../constants';
import { InternalNameStyled, TableCellStyled, TableRowStyled } from './styles';
import MoreDropdown from '../MoreDropdown';

interface Props {
  productTemplate: ProductTemplate;
}

const RFQProductTemplateRow: React.FC<Props> = observer((props) => {
  const history = useHistory();

  const { id, name, internalName, effectiveFrom, effectiveTo, createdOn, productLineId, filterBC, status } =
    props.productTemplate;

  const dateRange = `${normDateToShortAmericanDate(effectiveFrom)}-${normDateToShortAmericanDate(effectiveTo)}`;

  const redirectToProductTemplateChecklist = (): void => {
    history.push(`/product-template-checklist/${id}?type=templates`);
  };

  return (
    <TableRowStyled key={id} data-test-id={PRODUCT_TEMPLATES_TABLE_ROW_TEST_ID}>
      <TableCellStyled
        // Should match the width of the "External Name" column but with larger paddings.
        // This increases the total column width while keeping the content visually aligned.
        // Other columns should be adjusted accordingly to maintain consistent overall alignment.
        width="9rem"
        onClick={status === ProductTemplateStatus.ARCHIVE ? undefined : redirectToProductTemplateChecklist}
      >
        <InternalNameStyled>{internalName || name}</InternalNameStyled>
      </TableCellStyled>
      <TableCellStyled
        width="8rem"
        onClick={status === ProductTemplateStatus.ARCHIVE ? undefined : redirectToProductTemplateChecklist}
      >
        {name}
      </TableCellStyled>
      <TableCellStyled width="5rem">
        <StatusTag status={status} />
      </TableCellStyled>
      <TableCellStyled width="5rem">{PRODUCT_LINES_CONTENT_MAP[productLineId]?.label}</TableCellStyled>
      <TableCellStyled width="6rem">{dateRange}</TableCellStyled>
      <TableCellStyled width="6rem">{normDateToShortAmericanDate(createdOn)}</TableCellStyled>
      <TableCellStyled width="3rem">{filterBC?.state?.join(' ,') || ''}</TableCellStyled>
      <TableCellStyled width="4rem">
        <MoreDropdown
          productTemplate={props.productTemplate}
          editProductTemplate={redirectToProductTemplateChecklist}
        />
      </TableCellStyled>
    </TableRowStyled>
  );
});

export default RFQProductTemplateRow;
